import { render, staticRenderFns } from "./YleaderHistory.vue?vue&type=template&id=6e0059aa"
import script from "./YleaderHistory.vue?vue&type=script&lang=js"
export * from "./YleaderHistory.vue?vue&type=script&lang=js"
import style0 from "./YleaderHistory.vue?vue&type=style&index=0&id=6e0059aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports